import React, { useMemo } from 'react';
import moment from 'moment';
import { StyledWrapper, FormInputWrapper, StyledImgTitle } from './index.styled';
import { Form, message, Select } from 'antd';
import { FormItem, Authenticatable, TimePicker, Button } from 'components/elements';
import { useCreateReminderMutation, useGetMyAccountQuery, useGetMyPersonalEventsQuery } from 'graphql/types';
import { useHistory } from 'react-router-dom';

export const uiTimeFormat = 'hh:mm a';
export const serverTimeFormat = 'HH:mm:ss.SSS';
export const mapSubject = {
  nabor: 'Nabor Days',
  gohanbar: 'Gāhānbār days',
  important: 'Important days',
  semiImportant: 'Semi important days',
  ziyarat: 'Zīyārat days',
};

export const mapDaysBefore = ['Day of', '1 day before', '2 day before', '3 day before', '1 week before'];

const STATIC_SUBJECT_OPTIONS = [
  { value: 'nabor', label: 'Nabor Days' },
  { value: 'gohanbar', label: 'Gāhānbār days' },
  { value: 'important', label: 'Important days' },
  { value: 'semiImportant', label: 'Semi important days' },
  { value: 'ziyarat', label: 'Zīyārat days' },
];

export function getReminderSubjectLabel(subject: string) {
  return mapSubject[subject as keyof typeof mapSubject] ?? subject;
}

function AddReminder() {
  const history = useHistory();
  const { data: accountResult } = useGetMyAccountQuery();
  const { data: personalEventsResult } = useGetMyPersonalEventsQuery({
    skip: !accountResult?.myAccount?.data?.id,
  });
  const [addReminderForm] = Form.useForm();
  const [createReminder, { loading }] = useCreateReminderMutation();

  const subjectOptions = useMemo(() => {
    const personalEventOptions = (personalEventsResult?.myPersonalEvents ?? [])
      .filter((event): event is NonNullable<typeof event> => !!event?.subject?.trim())
      .map((event) => ({
        value: event.subject!.trim(),
        label: event.subject!.trim(),
      }));

    return [...STATIC_SUBJECT_OPTIONS, ...personalEventOptions];
  }, [personalEventsResult]);

  const onFinish = async (values: any) => {
    if (!accountResult?.myAccount?.data?.id) {
      return;
    }
    try {
      await createReminder({
        variables: {
          input: {
            ...values,
            time: values.time.format(serverTimeFormat),
          },
        },
      });

      message.success('Your Reminder created Successfully!');
    } catch (err) {
      if (err instanceof Error) {
        message.error(err?.message);
      }
    }
  };

  return (
    <StyledWrapper>
      <StyledImgTitle>Add Reminder</StyledImgTitle>
      <Form layout="vertical" form={addReminderForm} onFinish={onFinish} preserve={false}>
        <FormInputWrapper>
          I want to set email reminder
          <FormItem theme="primary" name="dayBefore" hasFeedback initialValue={0}>
            <Select
              style={{ width: 120 }}
              options={[
                { value: 0, label: 'Day of' },
                { value: 1, label: '1 day before' },
                { value: 2, label: '2 day before' },
                { value: 3, label: '3 day before' },
                { value: 7, label: '1 week before' },
              ]}
            />
          </FormItem>
          <FormItem theme="primary" name="subject" hasFeedback initialValue={'nabor'}>
            <Select
              showSearch
              optionFilterProp="label"
              options={subjectOptions}
              style={{ minWidth: 200 }}
            />
          </FormItem>
          at
          <FormItem theme="primary" name="time" hasFeedback initialValue={moment('7:00', uiTimeFormat)}>
            <TimePicker format={uiTimeFormat} />
          </FormItem>
        </FormInputWrapper>

        <Authenticatable
          title="For Create Reminder you need to login first!"
          okText="Login"
          onConfirm={() => history.push('/login')}
        >
          <Button onClick={() => addReminderForm.submit()} loading={loading} type="dashed">
            + Add Reminder
          </Button>
        </Authenticatable>
      </Form>
    </StyledWrapper>
  );
}
export default AddReminder;
